var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.877,
    height: 33.95,
    viewBox: "0 0 45.877 33.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "teeth-group",
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(-834.624 -165.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_66",
    "data-name": "Subtraction 66",
    d: "M23.177,0H4.813L0,6.345l1.471,9.487H23.177V0Z",
    transform: "translate(834.633 183.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_82",
    "data-name": "Subtraction 82",
    d: "M23.177,15.832H4.813L0,9.487,1.471,0H23.177V15.831Z",
    transform: "translate(834.633 165.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_78",
    "data-name": "Subtraction 78",
    d: "M23.177,0H4.813L0,6.345l1.471,9.487H23.177V0Z",
    transform: "translate(834.633 183.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_83",
    "data-name": "Subtraction 83",
    d: "M23.177,15.832H4.813L0,9.487,1.471,0H23.177V15.831Z",
    transform: "translate(834.633 165.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_76",
    "data-name": "Subtraction 76",
    d: "M23.177,0H4.813L0,6.345l1.471,9.487H23.177V0Z",
    transform: "translate(834.633 183.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_84",
    "data-name": "Subtraction 84",
    d: "M23.177,15.832H4.813L0,9.487,1.471,0H23.177V15.831Z",
    transform: "translate(834.633 165.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_79",
    "data-name": "Subtraction 79",
    d: "M23.177,0H4.813L0,6.345l1.471,9.487H23.177V0Z",
    transform: "translate(836.633 183.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_85",
    "data-name": "Subtraction 85",
    d: "M23.177,15.832H4.813L0,9.487,1.471,0H23.177V15.831Z",
    transform: "translate(836.633 165.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_68",
    "data-name": "Subtraction 68",
    d: "M23.177,15.832H4.813L0,9.487,1.471,0H23.177V15.831Z",
    transform: "translate(880.491 199.632) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_86",
    "data-name": "Subtraction 86",
    d: "M23.177,0H4.813L0,6.345l1.471,9.487H23.177V0Z",
    transform: "translate(880.491 181.75) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_80",
    "data-name": "Subtraction 80",
    d: "M23.177,15.832H4.813L0,9.487,1.471,0H23.177V15.831Z",
    transform: "translate(880.491 199.632) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_87",
    "data-name": "Subtraction 87",
    d: "M23.177,0H4.813L0,6.345l1.471,9.487H23.177V0Z",
    transform: "translate(880.491 181.75) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_77",
    "data-name": "Subtraction 77",
    d: "M23.177,15.832H4.813L0,9.487,1.471,0H23.177V15.831Z",
    transform: "translate(880.491 199.632) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_88",
    "data-name": "Subtraction 88",
    d: "M23.177,0H4.813L0,6.345l1.471,9.487H23.177V0Z",
    transform: "translate(880.491 181.75) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_81",
    "data-name": "Subtraction 81",
    d: "M23.177,15.832H4.813L0,9.487,1.471,0H23.177V15.831Z",
    transform: "translate(880.491 199.632) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_89",
    "data-name": "Subtraction 89",
    d: "M23.177,0H4.813L0,6.345l1.471,9.487H23.177V0Z",
    transform: "translate(880.491 181.75) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M.73,10.253H23.175V.777L-.012.731Z",
    transform: "translate(834.635 189.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M.73.731H23.175v9.477l-23.186.046Z",
    transform: "translate(834.635 165.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M.73,10.253H23.175V.777L-.012.731Z",
    transform: "translate(834.635 189.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M.73.731H23.175v9.477l-23.186.046Z",
    transform: "translate(834.635 165.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M.73,10.253H23.175V.777L-.012.731Z",
    transform: "translate(834.635 189.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M.73.731H23.175v9.477l-23.186.046Z",
    transform: "translate(834.635 165.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M.73,10.253H23.175V.777L-.012.731Z",
    transform: "translate(834.635 189.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M.73.731H23.175v9.477l-23.186.046Z",
    transform: "translate(834.635 165.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M22.433,10.253H-.012V.777L23.175.731Z",
    transform: "translate(857.325 189.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M22.433.731H-.012v9.477l23.186.046Z",
    transform: "translate(857.325 165.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M22.433,10.253H-.012V.777L23.175.731Z",
    transform: "translate(857.325 189.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M22.433.731H-.012v9.477l23.186.046Z",
    transform: "translate(857.325 165.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M22.433,10.253H-.012V.777L23.175.731Z",
    transform: "translate(857.325 189.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M22.433.731H-.012v9.477l23.186.046Z",
    transform: "translate(857.325 165.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M22.433,10.253H-.012V.777L23.175.731Z",
    transform: "translate(857.325 189.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M22.433.731H-.012v9.477l23.186.046Z",
    transform: "translate(857.325 165.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M22.689,9.522H.741L0,0,22.937.045,45.876,0l-.742,9.522Z",
    transform: "translate(834.624 190.228)",
    fill: "#fec5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_23",
    "data-name": "Union 23",
    d: "M22.69,0H.741L0,9.522l22.938-.045,22.939.045L45.135,0Z",
    transform: "translate(834.624 165.8)",
    fill: "#fec5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M22.689,9.522H.741L0,0,22.937.045,45.876,0l-.742,9.522Z",
    transform: "translate(834.624 190.228)",
    fill: "#fec5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_24",
    "data-name": "Union 24",
    d: "M22.69,0H.741L0,9.522l22.938-.045,22.939.045L45.135,0Z",
    transform: "translate(834.624 165.8)",
    fill: "#fec5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_20",
    "data-name": "Union 20",
    d: "M22.689,9.522H.741L0,0,22.937.045,45.876,0l-.742,9.522Z",
    transform: "translate(834.624 190.228)",
    fill: "#fec5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_25",
    "data-name": "Union 25",
    d: "M22.69,0H.741L0,9.522l22.938-.045,22.939.045L45.135,0Z",
    transform: "translate(834.624 165.8)",
    fill: "#fec5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    "data-name": "Union 22",
    d: "M22.689,9.522H.741L0,0,22.937.045,45.876,0l-.742,9.522Z",
    transform: "translate(834.624 190.228)",
    fill: "#fec5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_26",
    "data-name": "Union 26",
    d: "M22.69,0H.741L0,9.522l22.938-.045,22.939.045L45.135,0Z",
    transform: "translate(834.624 165.8)",
    fill: "#fec5c6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "mask",
    id: "Union_49",
    "data-name": "Union 49",
    transform: "translate(-863 -2128)",
    fill: "#2a3033"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M885.69,2161.95H863.742l-.742-9.523h.022l-.013-.081,4.813-6.346h36.232l4.812,6.345-.013.081h.022l-.742,9.523Zm0-18H867.822l-4.813-6.346.013-.081H863l.742-9.523h44.393l.742,9.523h-.022l.013.081-4.813,6.346Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "border",
    d: "M 906.2847900390625 2159.950439453125 L 906.7149658203125 2154.426513671875 L 906.5198974609375 2154.426513671875 L 906.7603149414063 2152.877685546875 L 903.0612182617188 2148.00048828125 L 888.1857299804688 2148.00048828125 L 886.1857299804688 2147.999755859375 L 886.1859130859375 2147.999755859375 L 868.8155517578125 2147.999755859375 L 865.1155395507813 2152.877685546875 L 865.355712890625 2154.426513671875 L 865.161865234375 2154.426513671875 L 865.5919799804688 2159.950439453125 L 885.6900024414063 2159.950439453125 L 906.2847900390625 2159.950439453125 M 903.0612182617188 2141.950439453125 L 906.7612915039063 2137.072265625 L 906.5210571289063 2135.5234375 L 906.7149658203125 2135.5234375 L 906.2848510742188 2129.999755859375 L 885.6900024414063 2129.999755859375 L 865.592041015625 2129.999755859375 L 865.161865234375 2135.5234375 L 865.3557739257813 2135.5234375 L 865.1155395507813 2137.072265625 L 868.8156127929688 2141.950439453125 L 869.8221435546875 2141.950439453125 L 885.69091796875 2141.950439453125 L 903.0612182617188 2141.950439453125 M 908.1351318359375 2161.950439453125 L 885.6900024414063 2161.950439453125 L 863.74169921875 2161.950439453125 L 863.0001220703125 2152.427490234375 L 863.0001831054688 2152.427490234375 L 863.0001220703125 2152.426513671875 L 863.0216674804688 2152.426513671875 L 863.0090942382813 2152.345458984375 L 867.8223266601563 2145.999755859375 L 886.1859130859375 2145.999755859375 L 888.1857299804688 2145.999755859375 L 888.1857299804688 2146.00048828125 L 904.0545043945313 2146.00048828125 L 908.8668212890625 2152.345458984375 L 908.854248046875 2152.426513671875 L 908.876708984375 2152.426513671875 L 908.8766479492188 2152.427490234375 L 908.876708984375 2152.427490234375 L 908.1351318359375 2161.950439453125 Z M 904.0545043945313 2143.950439453125 L 885.69091796875 2143.950439453125 L 869.8221435546875 2143.950439453125 L 867.8223266601563 2143.950439453125 L 863.0090942382813 2137.6044921875 L 863.0216674804688 2137.5234375 L 863.0001220703125 2137.5234375 L 863.0001831054688 2137.5224609375 L 863.0001220703125 2137.5224609375 L 863.74169921875 2127.999755859375 L 885.6900024414063 2127.999755859375 L 908.1351318359375 2127.999755859375 L 908.876708984375 2137.5224609375 L 908.8766479492188 2137.5224609375 L 908.876708984375 2137.5234375 L 908.8551635742188 2137.5234375 L 908.8677368164063 2137.6044921875 L 904.0545043945313 2143.950439453125 Z",
    stroke: "none",
    fill: "#fff",
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontView);
export default __webpack_public_path__ + "static/media/FrontView.6678e515b0fdfeb743cae918aa7b6f25.svg";
export { ForwardRef as ReactComponent };